var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.539a6.555 6.555 0 0 1-1.885.517A3.287 3.287 0 0 0 15.558.24a6.577 6.577 0 0 1-2.085.796A3.285 3.285 0 0 0 7.88 4.03 9.32 9.32 0 0 1 1.114.601a3.286 3.286 0 0 0 1.015 4.381 3.27 3.27 0 0 1-1.486-.41c-.036 1.52 1.054 2.942 2.633 3.26a3.29 3.29 0 0 1-1.483.055 3.285 3.285 0 0 0 3.067 2.279A6.601 6.601 0 0 1 0 11.526 9.294 9.294 0 0 0 5.032 13c6.095 0 9.538-5.146 9.33-9.762A6.683 6.683 0 0 0 16 1.539Z",
    fillOpacity: 0.4
  })));
};
export default SvgTwitter;